/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SocialNetworkPostDto { 
    id?: number;
    uuid?: string;
    created?: string;
    imageProof?: string;
    link?: string;
    postType?: SocialNetworkPostDto.PostTypeEnum;
    socialNetwork?: SocialNetworkPostDto.SocialNetworkEnum;
    userId?: number;
    email?: string;
    status?: SocialNetworkPostDto.StatusEnum;
    statusUpdatedAt?: string;
    declineReason?: string;
}
export namespace SocialNetworkPostDto {
    export type PostTypeEnum = 'STORY' | 'POST';
    export const PostTypeEnum = {
        Story: 'STORY' as PostTypeEnum,
        Post: 'POST' as PostTypeEnum
    };
    export type SocialNetworkEnum = 'FACEBOOK' | 'INSTAGRAM';
    export const SocialNetworkEnum = {
        Facebook: 'FACEBOOK' as SocialNetworkEnum,
        Instagram: 'INSTAGRAM' as SocialNetworkEnum
    };
    export type StatusEnum = 'VALIDATING' | 'APPROVED' | 'REWARDED' | 'DECLINED';
    export const StatusEnum = {
        Validating: 'VALIDATING' as StatusEnum,
        Approved: 'APPROVED' as StatusEnum,
        Rewarded: 'REWARDED' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum
    };
}


